'use client'

import { Home } from "lucide-react"
import { Button } from "./elements/Button"

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center">
      <h1 className="text-6xl font-bold text-gradient">404</h1>
      <h2 className="mt-2 text-xl font-gilroy font-semibold">Таны хайсан хуудас олдсонгүй</h2>
      <p className="text-sm font-medium text-muted-foreground mt-2">Уучлаарай, таны хайсан хуудас олдсонгүй. Холбоосоо дахин нэг шалгаж үзнэ үү.</p>
      <Button tag="a" href="/" icon={Home} className="mt-8">Самбар луу буцах</Button>
    </div>
  )
}